import "./About.css";

function About() {
  return (
    <section id="about" className="about">
      <h2>Hakkımızda</h2>
      <p>
        <strong>Soft Touch Oto Dizayn</strong>, İstanbul Beylikdüzü Autopia AVM’de 
        araç iç dizayn, döşeme ve restorasyon alanında uzmanlaşmış bir atölyedir. 
        Yılların deneyimi ve profesyonel ekibimiz ile 
        aracınızın iç mekanını estetik ve fonksiyonel açıdan 
        yeniden tasarlıyoruz.
      </p>
      <p>
        Hizmetlerimiz arasında <strong>oto döşeme</strong>, 
        <strong> tuş & trim yenileme</strong>, 
        <strong> direksiyon deri kaplama</strong>, 
        <strong> koltuk boyama</strong>, 
        <strong> tavan & kapı döşeme yenileme</strong> ve 
        <strong> pasta cila & iç kuaför</strong> yer almaktadır. 
        BMW, Mercedes-Benz, Audi, Volkswagen, Renault, Peugeot, Fiat, Toyota, Ford, Volvo, 
        Range Rover, Porsche, Opel, Honda ve daha birçok araç markasına profesyonel çözümler sunuyoruz.
      </p>
      <p>
        Özellikle <em>BMW oto döşeme</em>, <em>Mercedes direksiyon kaplama</em>, 
        <em>Audi trim restorasyonu</em>, <em>Volkswagen tavan kaplama</em>, 
        <em>Renault koltuk boyama</em> ve <em>Volvo iç kuaför</em> gibi 
        marka + hizmet kombinasyonlarında İstanbul genelinde tercih edilen atölyelerden biriyiz. 
        Modern teknikler ve kaliteli malzemelerle uzun ömürlü çözümler üretiyoruz.
      </p>
      <p>
        Amacımız müşterilerimize yalnızca bir hizmet değil, aynı zamanda 
        <strong> güven, kalite ve prestij</strong> sunmaktır. 
        Aracınız için en doğru ve estetik çözümleri bulmak üzere 
        <strong> Soft Touch Oto Dizayn</strong>’a sizleri de bekliyoruz.
      </p>
    </section>
  );
}

export default About;
